import { render, staticRenderFns } from "./ItemSpecification.vue?vue&type=template&id=438735b2"
import script from "./ItemSpecification.vue?vue&type=script&lang=js"
export * from "./ItemSpecification.vue?vue&type=script&lang=js"
import style0 from "./ItemSpecification.vue?vue&type=style&index=0&id=438735b2&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('438735b2')) {
      api.createRecord('438735b2', component.options)
    } else {
      api.reload('438735b2', component.options)
    }
    module.hot.accept("./ItemSpecification.vue?vue&type=template&id=438735b2", function () {
      api.rerender('438735b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/elements/modelcomparison/assets/frontend/components/ItemSpecification.vue"
export default component.exports